import axios from '../../admin-axios';
import { detectError } from '../../utils';
import ActionType from '../action-types';

// eslint-disable-next-line import/prefer-default-export
export const getApprovedTransactions = (stationId, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_APPROVED_TRANSACTIONS_START,
      payload: { page }
    });

    try {
      // send request to get approved transactions
      const response = await axios.get(`/transaction/approved/${stationId}?page=${page}`);
      dispatch({
        type: ActionType.FETCH_APPROVED_TRANSACTIONS_SUCCESS,
        payload: {
          transactions: response.data.data.data,
          total: response.data.data.total,
          current_page: response.data.data.current_page,
          per_page: response.data.data.per_page
        } // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.FETCH_APPROVED_TRANSACTIONS_ERROR,
        payload: message
      });
    }
  };
};

export const searchApprovedTransactions = (query) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.APPROVED_TRANSACTIONS_SEARCH_START
    });

    try {
      // send request to get approved transactions
      const response = await axios.get(`/transaction/search/approved/${query}`);
      dispatch({
        type: ActionType.APPROVED_TRANSACTIONS_SEARCH_SUCCESS,
        payload: [response.data.data] // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.APPROVED_TRANSACTIONS_SEARCH_ERROR,
        payload: message
      });
    }
  };
};

export const filterApprovedTransactions = (date, stationId, page) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FILTER_APPROVED_TRANSACTIONS_START
    });

    try {
      // send request to get approved transactions
      const response = await axios.post(`/transaction/approved/date/${stationId}?page=${page}`, {
        date
      });
      dispatch({
        type: ActionType.FILTER_APPROVED_TRANSACTIONS_SUCCESS,
        payload: response.data.data // response data
      });
    } catch (error) {
      const message = detectError(error);
      dispatch({
        type: ActionType.FILTER_APPROVED_TRANSACTIONS_ERROR,
        payload: message
      });
    }
  };
};

export const setApprovedView = (view) => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.SET_APPROVED_TRANSACTIONS_VIEW,
      payload: view
    });
  };
};
